import { useMemo, useState } from 'react';

import { useFeatureFlag_Core } from 'core';
import { DownloadGivebacksAppQRCodeModal } from 'core/Components';
import { usePlatformService } from 'core/Hooks';
import { NavLink, useNavigate } from 'react-router-dom';
import { Button } from 'ui';

type TicketActionButtonsProps = {
  isAuthenticated: boolean;
  DownloadButton: React.ReactNode;
  checkoutId?: string;
  cartId?: string;
  email?: string;
};

const TicketActionButtons = ({
  isAuthenticated,
  DownloadButton,
  checkoutId,
  email,
  cartId,
}: TicketActionButtonsProps) => {
  const platform = usePlatformService();
  const [isGetAppModalOpen, setIsGetAppModalOpen] = useState(false);
  const navigate = useNavigate();
  const { isFeatureEnabled: isAccountPageEnabled } = useFeatureFlag_Core({
    featureId: 'user.account_page',
  });

  const receiptSearchParams = useMemo(() => {
    const params = new URLSearchParams();
    if (checkoutId) {
      params.append('checkout_id', checkoutId);
    }
    if (email) {
      params.append('email', email);
    }
    if (cartId) {
      params.append('cart_id', cartId);
    }
    return params;
  }, [checkoutId, email, cartId]);

  const isReceiptButtonVisible = useMemo(() => {
    return cartId || checkoutId;
  }, [cartId, checkoutId]);

  return (
    <>
      {DownloadButton && DownloadButton}
      {isAuthenticated ? (
        <Button
          variant="outline"
          onClick={() => navigate(isAccountPageEnabled ? '/account' : '/wallet')}
        >
          View In Wallet
        </Button>
      ) : (
        <>
          <Button
            hiddenFrom="sm"
            variant="primary"
            onClick={() => {
              if (platform.mobileBrowser) {
                return window.open('https://api.givebacks.com/magic', '_blank');
              }

              setIsGetAppModalOpen(true);
            }}
          >
            Get the App
          </Button>
        </>
      )}
      {isReceiptButtonVisible ? (
        <Button
          component={NavLink}
          to={`/post-checkout/pos-receipt?${receiptSearchParams.toString()}`}
          variant="outline"
        >
          View Receipt
        </Button>
      ) : null}
      <DownloadGivebacksAppQRCodeModal
        opened={isGetAppModalOpen}
        onClose={() => setIsGetAppModalOpen(false)}
      />
    </>
  );
};

export default TicketActionButtons;
